import React, { Component } from 'react';
import BasicLoader from '../../../../../../util/BasicLoader';
import VenueTriggerSlide from '../../../../../Triggers/VenueTriggerSlide';
import CityTriggerSlide from '../../../../../Triggers/CityTriggerSlide';
import OccasionTriggerSlide from '../../../../../Triggers/OccasionTriggerSlide';

class StaticTriggerSlide extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  };

  render() {
    let segment ;
    let activeSlide = this.props.activeSlide;
    if(activeSlide === 'city') {
      segment = <CityTriggerSlide
        handleClick={this.props.handleCityChange}
      />;
    } else if(activeSlide === 'venue') {
      segment = <VenueTriggerSlide
        handleClick={this.props.handleVenueChange}
        venue={this.props.venueSlideData}
      />;
    } else if (activeSlide === 'occasion') {
      segment = <OccasionTriggerSlide
        handleClick={this.props.handleOccasionChange}
      />;
    } else {
      segment = <BasicLoader />
    }
    return (
      <div>
        {segment}
      </div>
    );
  }
}

export default StaticTriggerSlide;
